<template><div class="view">

	<main>

		<blocks v-if="!editing_blocks" :blocks="blocks" />
		<block-editor v-if="editing_blocks" :blocks="blocks" :route_name="$route.name" :page_slug="blocks_pagekey" @updated="blocksUpdated()" />
		
	</main>


</div></template>
<script>
import mixins from '.././mixins.js'
import store from '.././store/store.js'

import Blocks from '.././components/Blocks'
import BlockEditor from '.././views/admin/AdminBlockEditor'

export default {
	
	mixins: [ mixins.generic ],
	
	components: {
		Blocks, BlockEditor, 
	},

	data(){ return {
			

	}},

	computed: {

		gender(){ return this.$route.params.gender },
		book(){ return this.$route.params.book },

		blocks_pagekey(){
			var page_key = 'artists-' + this.book
			if( this.gender ) var page_key = 'artists-' + this.gender + '-' + this.book		
			return page_key
		},

		blocks(){ return this.$store.state.loaded_blocks },

	},

	methods: {

		load_blocks(){
			
			var _this = this

			var page_key = this.blocks_pagekey
			if( !page_key ) return

			this.$store.commit('set_loaded_blocks', undefined )

			this.fetch( 'get_blocks_by_pagekey', { page_key:page_key, }, 
			{ onSuccess: function(output){
				
				if( !output.data || !output.data.blocks ) {
					console.log('valid request, but missing data')												
					return
				}

				_this.$store.commit('set_loaded_blocks', output.data.blocks )

			}, onError: function(output){

				console.log('NAH - fetched but with error',output)		

			}})
				
		},

		blocksUpdated(){
			this.load_blocks()
		},


	},

	watch: {
		'$route' (to, from) {
			this.load_blocks()
		}
	},
	
	mounted(){
		this.load_blocks()
		this.setDocumentTitle('Artists')
	},

}
</script>



// WEBPACK FOOTER //
// src/views/ArtistList.vue